<template>
  <div id="home-page" class="container-fluid container h-100">

    <error-block :title="$t('dss.error.title')" :message="$t('dss.error.generic')" v-if="!status"/>
    <error-block :title="$t('dss.error.title404')" :message="$t('dss.error.404')" v-if="status==='404'"/>
    <error-block :title="$t('dss.error.title403')" :message="$t('dss.error.403')" v-if="status==='403'"/>

  </div>
</template>

<script lang="ts">
import ErrorBlock from '@/components/ui/ErrorBlock.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'GenericError',
  components: { ErrorBlock },
  computed: {
    status() {
      return this.$route.params.status as string;
    },
  },
});
</script>

<style scoped>

</style>
